import React, { useEffect, useState } from 'react';
import ButtonUI from '../../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { translate } from '../../../../utils/util';
import M from 'materialize-css/dist/js/materialize';
import { validateInputsRequired, onValueChange } from '../../../../utils/handleChangeHooks';
import InputUI from '../../../../components/UI/InputUI';
import { ScannerCode } from '../../../../components/UI/ComponentsUI';

const ConfirmModalQuantity = (props) => {
    const defaultValues = {
        quantity: 0,
        qrCode: ''
    }
    const [model, setModel] = useState(defaultValues);

    useEffect(() => {
        return () => {
            if (props.onClose) {
                props.onClose();
            }
            setModel({ ...defaultValues });
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        return () => {
            setModel({ ...defaultValues });
        }
        // eslint-disable-next-line
    }, [props.open]);


    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onConfirm = () => {
        if (props.lastReadingQuantity > 0 || model.qrCode.length >= 2) {
            if (props.onConfirm && validateInputsRequired("formInput")) {
                props.onConfirm(model);
                close();
            }
        }
    }

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    const scanner = (value) => {
        if (value.length >= 2) {
            model.qrCode = value;
            setModel({ ...model }, () => { M.updateTextFields(); });
        }
    };

    return (
        <Modal
            options={{
                dismissible: false
            }}
            open={props.open}
            id={props.lotItemId || 'ModalQuantityClosed'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={onConfirm} text={props.btnConfirm ? props.btnConfirm : translate('confirm', 'general')} />
                </Row>
            }
        >
            <div>
                {
                    props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">{props.title}</span>
                                <span className="col s12" >{props.content}</span>
                            </div>
                        </Row>
                        <div id="formInput" className="row" style={{ marginBottom: '0px' }}>
                            <div className="padding col s12">
                                <InputUI
                                    label={translate('inventory:quantity')}
                                    required
                                    id="quantity"
                                    name="quantity"
                                    step="1"
                                    type="number"
                                    maxLength="11"
                                    onChange={onChange} />
                            </div>
                            {props.lastReadingQuantity === 0 &&
                                <div className="padding col s12">
                                    <div className="input-field no-padding col s6">
                                        <ScannerCode className="mdi mdi-qrcode-scan posfix" onScanner={scanner} />
                                        <input disabled onChange={onChange} name="qrCode" id="qrCode" type="text" placeholder={translate('general.validate')} defaultValue={model.qrCode} />
                                    </div>
                                    <div className="input-field no-padding col s2">
                                        {
                                            model.qrCode.length >= 2 ? (
                                                <i className="mdi mdi-checkbox-marked-circle-outline right f-2r" style={{ color: 'green' }} />
                                            ) : (
                                                <i className="mdi mdi-alert-circle-outline right f-2r" style={{ color: 'red' }} />
                                            )
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </Modal>
    )
}

export default ConfirmModalQuantity;
